import { useQuery } from 'react-query';

import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import { AudioSpeakerFiles, MatterSpeakers } from '../types/backend-dto-types';
import useGetFetchConfig from '../useGetFetchConfig';

export const useGetAudioSpeakerFiles = (matterId: string | undefined) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<AudioSpeakerFiles>(
    [QueryEntity.AudioSpeakerFiles, { matterId }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/audio/speaker-files`, fetchConfigGET);
      if (!response.ok) throw new Error('Fetching audio speaker files failed');
      return response.json();
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
    },
  );
};

export const useGetMatterSpeakers = (matterId: string | undefined) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<MatterSpeakers>(
    [QueryEntity.MatterAudioSpeakers, { matterId }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/matters/${matterId}/audio/speakers`, fetchConfigGET);
      if (!response.ok) throw new Error('Fetching speakers failed');
      return response.json();
    },
    {
      enabled: !!matterId,
      refetchOnWindowFocus: false,
    },
  );
};
